export default "__VITE_PUBLIC_ASSET__32f6c488__"